<template>
  <div>
    <div class="topLayout">
      <div class="calendarLayout">
        <yd-cell-item arrow style="float:left; width:50%;">
          <span slot="left">开始：</span>
          <yd-datetime slot="right" type="date" :start-date="startDate" v-model="selectedFromDate" :callback='selectedCertainDate'></yd-datetime>
        </yd-cell-item>
        <yd-cell-item arrow style="float:right; width:50%;">
          <span slot="left">截止：</span>
          <yd-datetime slot="right" type="date" :start-date="startDate" v-model="selectedToDate" :callback='selectedCertainDate'></yd-datetime>
        </yd-cell-item>
      </div>
    </div>
    <div class="listContentLayout">
      <div class="barlineLayout"></div>
      <div class="titleLayout">{{name}}</div>
      <div class="singleLine"></div>
      <div>
        <yd-accordion accordion>
          <yd-accordion-item title="出行数据">
            <div class="singleLine"></div>
              <div class="infoLayout">
                <p>出行人数：{{orderInfo['count(*)']}}人</p>
                <p>应收金额：<span>¥{{orderInfo['sum(totalPrice)']}}</span></p>
                <p>已收金额：<span>¥{{orderInfo['sum(paid)']}}</span></p>
              </div>
          </yd-accordion-item>
        </yd-accordion>
      </div>
      <div>
        <div class="barlineLayout"></div>
        <yd-accordion accordion>
          <yd-accordion-item title="组团社数据">
            <div class="singleLine"></div>
            <div class="infoLayout" v-if="tours && tours.length>0">
              <div v-for="(item, index) in tours" :key="index">
                <p>{{item.groupClubName}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{item['count(groupClubName)']}}人</p>
              </div>
            </div>
          </yd-accordion-item>
        </yd-accordion>
      </div>
      <div>
        <div class="barlineLayout"></div>
        <yd-accordion accordion>
          <yd-accordion-item title="出团数据">
            <div class="singleLine"></div>
              <div class="infoLayout">
                <p>出团开销：<span>¥{{groupCost}}</span></p>
                <p>报账花销：<span>¥{{voucherCost}}</span></p>
                <div style="height:12px"></div>
                <ul>
                  <li v-for="(item, index) in records" :key="index" type="disc">
                    {{item.name}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span>¥{{item.cost}}</span>
                  </li>
                </ul>
              </div>
          </yd-accordion-item>
        </yd-accordion>
      </div>
    </div>   
  </div>
</template>

<script>
import appService from "@/services/request/appService"
import store from 'store'
export default {
  name: 'Analysis',
  data(){
    return{
      mine:{},
      activityId:this.$route.query.id,
      selectedFromDate:this.$route.query.fromdate,
      selectedToDate:this.$route.query.todate,
      name:this.$route.query.name,
      startDate:'',
      firstLoadEnd: false,
      orderInfo:{
        'count(*)': 0,
        'sum(totalPrice)':0,
        'sum(paid)':0,
      },
      tours:[],
      releaseTourInfo:{},
      groupCost:0, //出团开销
      voucherCost:0, //报账开销
      records:[],
    }
  },
  mounted:function(){
    this.$nextTick(function(){
      document.title = '线路营收分析'
      this.mine = store.get('mine')
      this.initCalendarDate()
      this.updateCommpontsStyle()
      this.loadData(() => {
        this.loadSupplementData()
      })
    })
  },
  methods:{
    initCalendarDate() {
      var startDateTemp = new Date();
      var seperator = "-";
      var year = startDateTemp.getFullYear();
      var month = startDateTemp.getMonth() + 1;
      var day = startDateTemp.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (day >= 0 && day <= 9) {
        day = "0" + day;
      }
      this.startDate = (year-1) + seperator + month + seperator + day
    },
    loadData(callback) {
      var fromTimeStamp = this.changeDateToTimeStamp(this.selectedFromDate)
      var toTimeStamp = this.changeDateToTimeStamp(this.selectedToDate)
      appService
        .getOperationActivityAnalysisData({
          activityId: this.activityId,
          unionId: store.get('loginData') ? store.get('loginData').id : this.mine.unionId,
          startTime: fromTimeStamp,
          endTime: toTimeStamp,
          iid: this.$route.query.iid,
          saleIid:this.$route.query.saleIid?this.$route.query.saleIid:''
        })
        .then(data => {
          this.firstLoadEnd = true
          if(data.club) this.tours = data.club
          if(data.sum) this.orderInfo = data.sum
          if ( typeof callback === "function" ) callback()
        }, error => {
          this.firstLoadEnd = true
        })
    },
    loadSupplementData() {
      var fromTimeStamp = this.changeDateToTimeStamp(this.selectedFromDate)
      var toTimeStamp = this.changeDateToTimeStamp(this.selectedToDate)
      appService
        .getOperationActivityAnotherAnalysisData({
          activityId: this.activityId,
          unionId: store.get('loginData') ? store.get('loginData').id : this.mine.unionId,
          startTime: fromTimeStamp,
          endTime: toTimeStamp,
          iid: this.$route.query.iid,
          saleIid:this.$route.query.saleIid?this.$route.query.saleIid:''
        })
        .then(data => {
          this.groupCost = data.groupCost
          this.voucherCost = data.voucherCost
          this.records = data.records
        }, error => {

        })
    },
    changeDateToTimeStamp(dateStr) {
      var date = new Date(dateStr)
      var timeStamp = date.getTime()
      return timeStamp
    },
    selectedCertainDate() {
      if(this.firstLoadEnd) {
        this.loadData()
      }
    },
    updateCommpontsStyle() {
      var elements = window.document.getElementsByTagName('span')
      for(var i = 0; i < elements.length; i++) {
        var el = elements[i]
        if(el.innerHTML == '出行数据' ||
          el.innerHTML == '组团社数据' ||
          el.innerHTML == '出团数据') {
          const styleObj = el.style
          styleObj.setProperty('font-size', '0.32rem');
        }
      }
    }
  }
}
</script>

<style scoped>
.page{
  font-size: 0.24rem;
}
.topLayout{
  position: absolute;
  top: 0;
  width: 100%;
  height: 1rem;
}
.topLayout .calendarLayout{
  display:flex;
  width:100%;
  margin:0;
  padding:0;
  background-color:white;
}
.titleLayout{
  padding: 12px;
  font-size: 0.36rem;
  background-color: white;
  color: #333;
}
.listContentLayout{
  position: absolute;
  top: 0;
  width: 100%;
  bottom: 0;
  margin-top: 1rem;
  -webkit-overflow-scrolling: touch;
  overflow-y: scroll;
}
.infoLayout{
  padding: 12px;
  font-size: 0.28rem;
}
.infoLayout p{
  padding: 4px;
}
.infoLayout ul{
  margin-left: 20px;
}
.infoLayout span{
  color: green;
}
.groupInfoLayout{
  padding: 4px 12px;
  font-size: 0.28rem;
}
.barlineLayout{
  height:10px;
  background-color: #f6f6f6;
  width: 100%;
}
.singleLine{
  width: 100%;
  height: 1px;
  background-color: #f6f6f6;
}
</style>
